import { render, staticRenderFns } from "./AttestationBadge.vue?vue&type=template&id=299f1b6d&"
import script from "./AttestationBadge.vue?vue&type=script&lang=js&"
export * from "./AttestationBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports